import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import { FeedbackMessageModel } from '../../hooks/useFeedbackMessages';
import * as i18next from 'i18next';
import moment from 'moment';

interface IProps {
    show: boolean;
    message: FeedbackMessageModel;
    messageSent: boolean;
    close: () => void;
    openSite: (siteId: number) => void;
    markAsDone: (message: FeedbackMessageModel) => void;
}

export default function AdminFeedbackMessageModal({ show, message, messageSent, close, openSite, markAsDone }: IProps) {
    return (
        <Dialog open={show} onClose={() => close()}>
            <DialogTitle sx={{ bgcolor: 'primary.main', color: 'white', pr: 6 }}>
                {i18next.t('adminfeedback.modaltitle')}
                <IconButton onClick={() => close()} size="small" sx={{ position: 'absolute', right: 8, top: 8, color: 'white' }}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2 }}>
                {messageSent
                    ? <Typography>{i18next.t('adminfeedback.messagesent')}</Typography>
                    : <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Typography sx={{ minWidth: 120, fontWeight: 600 }}>{i18next.t('adminfeedback.created')}:</Typography>
                            <Typography>{moment(message.createdDate).format('L')}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Typography sx={{ minWidth: 120, fontWeight: 600 }}>{i18next.t('adminfeedback.driverid')}:</Typography>
                            <Typography>{message.driverId}</Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Typography sx={{ minWidth: 120, fontWeight: 600 }}>{i18next.t('adminfeedback.siteid')}:</Typography>
                            <Typography component="a" onClick={() => openSite(message.uniqueSiteId)} sx={{ cursor: 'pointer', color: 'secondary.main' }}>
                                {message.siteName}
                            </Typography>
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Typography sx={{ minWidth: 120, fontWeight: 600 }}>{i18next.t('adminfeedback.message')}:</Typography>
                            <Typography sx={{ wordBreak: 'break-word', whiteSpace: 'pre-line' }}>{message.message}</Typography>
                        </Box>
                    </Box>
                }
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                {!messageSent && (
                    <Button variant="contained" color="primary" onClick={() => markAsDone(message)}>{i18next.t('adminfeedback.complete')}</Button>
                )}
                <Button variant="outlined" color="inherit" onClick={() => close()}>{i18next.t('adminfeedback.closebutton')}</Button>
            </DialogActions>
        </Dialog>
    );
}
